import React, { Fragment, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Dropdown from 'react-bootstrap/Dropdown'
import { TopbarSettingsBox } from './style'
import { redirectLogin } from '../../helper/helper'
import Modal from 'react-modal'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { allAccountByToken } from '../../apis/account/api'

import { userProfile } from '../../apis/login/api'
var isShowMenu = false

const TopbarSettingsComponent = (props) => {
  const { accountId, workspaceId } = useParams()
  const [accountList, setAccountList] = useState([])
  const [workspace, setWorkspace] = useState([])
  const [activeWorkspace, setActiveWorkspace] = useState('')
  const [activeAccount, setActiveAccount] = useState([])

  const accessToken = localStorage.getItem('token')
  const [showDropdownAccount, setShowDropdownAccount] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [userName, setUserName] = useState(false)
  const [openPopupAccountSuspended, setOpenPopupAccountSuspended] =
    useState(false)
  const [activePlanName, setActivePlanName] = useState(false)

  const customStylesMD = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '436px',
    },
  }

  const logout = () => {
    redirectLogin()
  }

  useEffect(() => {
    getAccountList(accessToken)
    getUserProfile(accessToken)
    // ;(function () {
    //   function onTidioChatApiReady() {
    //     window.tidioChatApi.hide()
    //     window.tidioChatApi.on('close', function () {
    //       window.tidioChatApi.hide()
    //     })
    //   }

    //   if (window.tidioChatApi) {
    //     window.tidioChatApi.on('ready', onTidioChatApiReady)
    //   } else {
    //     document.addEventListener('tidioChat-ready', onTidioChatApiReady)
    //   }
    // })()
  }, [])

  const handleSelectAccount = (accountInfo) => {
    setWorkspace(accountInfo.workspace_list)
    setActiveAccount(accountInfo)
    handleActivePlanName(accountInfo.plan_name)
  }
  const handleActivePlanName = (plan) => {
    if (plan) {
      if (plan === 'Basic') {
        setActivePlanName(false)
      } else if (plan === 'Free') {
        setActivePlanName(false)
      } else {
        setActivePlanName(true)
        var my_awesome_script = document.createElement('script')
        my_awesome_script.setAttribute(
          'src',
          '//js-na1.hs-scripts.com/44766923.js',
        )
        my_awesome_script.setAttribute('id', 'hs-script-loader')
        my_awesome_script.setAttribute('async', true)
        my_awesome_script.setAttribute('defer', true)
        document.head.appendChild(my_awesome_script)
      }
    } else {
      setActivePlanName(false)
    }
  }
  const getAccountList = async (token) => {
    const { data, status } = await allAccountByToken(token)
    if (status === 200) {
      setAccountList(data.data.account_list.filter((item) => !item.deleted))
      const selectedAccount = data.data.account_list.filter(
        (item) => item.id === accountId,
      )
      if (selectedAccount.length > 0) {
        setActiveAccount(selectedAccount[0])
        setWorkspace(selectedAccount[0].workspace_list)
        handleActivePlanName(selectedAccount[0].plan_name)

        if (props.accountDetailFn) {
          props.accountDetailFn(selectedAccount)
        }
        if (workspaceId) {
          let selectedWorkspace = selectedAccount[0].workspace_list.filter(
            (item) => item.id === workspaceId,
          )

          setActiveWorkspace(selectedWorkspace[0])
        } else {
          setActiveWorkspace(selectedAccount[0].workspace_list[0])
        }
      }
    }
  }
  const handleClickOutside = (event) => {
    try {
      if (
        !event?.target?.className?.includes('menu-topbar') &&
        !event?.target?.className?.includes('dropdown_account') &&
        !event?.target?.className?.includes('icon-name-info')
      ) {
        if (event?.target?.className?.includes('innerPanel')) {
          isShowMenu = !isShowMenu
          setShowDropdownAccount(isShowMenu)
        } else {
          setShowMenu(false)
          setShowDropdownAccount(false)
        }
      } else {
        if (event?.target?.className?.includes('icon-name-info')) {
          isShowMenu = !isShowMenu
          setShowMenu(isShowMenu)
        }
      }
    } catch (error) {
      setShowMenu(false)
      setShowDropdownAccount(false)
    }
  }

  const selectedWorkspace = (workspaceInfo) => {
    setActiveWorkspace(workspaceInfo)
    setShowDropdownAccount(false)
    let page = window.location.pathname.split('/')[1]
    if (activeAccount?.state !== 'suspend') {
      window.location.href = `/${page}/${workspaceInfo.account_id}/${workspaceInfo.id}`
    } else {
      if (activeAccount.role === 'SuperAccountAdmin') {
        window.location.href = `/package/${workspaceInfo.account_id}`
      } else {
        setOpenPopupAccountSuspended(true)
      }
    }
  }
  const getUserProfile = async () => {
    const { data, status } = await userProfile(accessToken)
    if (status === 200) {
      localStorage.setItem('u_', data.data.email)
      setUserName(data.data.name.charAt(0).toUpperCase())
    }
  }

  useEffect(() => {
    window.addEventListener('click', handleClickOutside)
    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [handleClickOutside])

  const handleDropdown = () => {
    setShowDropdownAccount(true)
  }

  const handleOpenChat = () => {
    // window.tidioChatApi.open()
    // window.tidioChatApi.display(true)
    // var my_awesome_script = document.createElement('script')
    // my_awesome_script.setAttribute('src', '//js-na1.hs-scripts.com/44766923.js')
    // my_awesome_script.setAttribute('id', 'hs-script-loader')
    // my_awesome_script.setAttribute('async', true)
    // my_awesome_script.setAttribute('defer', true)
    // document.head.appendChild(my_awesome_script)

    // setTimeout(() => {
    window.HubSpotConversations.widget.open()
    // }, 500)
  }

  return (
    <TopbarSettingsBox>
      <div className="topbar-box d-grid-topbar">
        <div className="d-flex justify-content-between">
          <div className="d-flex justify-content-start">
            <div
              className={`cursor  img-logo-box ${
                props.accountDetailFn === 'profile' ? 'border-0' : ' '
              }`}
              onClick={() => (window.location.href = '/home')}
            >
              <img
                src="/assets/img/logo-Tagtb.svg"
                className="img-180"
                alt="Tag Turbo"
              />
            </div>
            {props.accountDetailFn === 'profile' ? (
              <Fragment />
            ) : (
              <Fragment>
                <div className="border-end px-2 innerPanel"></div>

                {activeAccount && (
                  <div
                    className="d-flex mx-3 justify-content-between rounded innerPanel"
                    onClick={() => handleDropdown()}
                  >
                    <div className="mx-4 text-left innerPanel">
                      <p className="m-0 text-12 innerPanel">
                        {activeAccount.name}
                      </p>
                      <p className="m-0 text-12 text-semibold innerPanel">
                        {activeWorkspace?.name || '-'}
                      </p>
                    </div>
                    <div className="p-1 px-2 innerPanel text-semibold">
                      <span className="arrow">
                        <span className="arrow-span-left"></span>
                        <span className="arrow-span-right"></span>
                      </span>
                    </div>
                  </div>
                )}
              </Fragment>
            )}
          </div>

          <div className="d-flex item-center">
            <Fragment>
              {props.accountDetailFn === 'profile' ? (
                <Fragment />
              ) : (
                <Dropdown className="mx-0 cursor">
                  <Dropdown.Toggle className="dropdown-outline">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <mask
                        id="mask0_14619_48152"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="18"
                        height="18"
                      >
                        <rect width="18" height="18" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_14619_48152)">
                        <path
                          d="M8.9625 13.5C9.225 13.5 9.44688 13.4094 9.62813 13.2281C9.80938 13.0469 9.9 12.825 9.9 12.5625C9.9 12.3 9.80938 12.0781 9.62813 11.8969C9.44688 11.7156 9.225 11.625 8.9625 11.625C8.7 11.625 8.47813 11.7156 8.29688 11.8969C8.11562 12.0781 8.025 12.3 8.025 12.5625C8.025 12.825 8.11562 13.0469 8.29688 13.2281C8.47813 13.4094 8.7 13.5 8.9625 13.5ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69687 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69687 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69687 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69687 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9 15C10.675 15 12.0938 14.4187 13.2563 13.2563C14.4187 12.0938 15 10.675 15 9C15 7.325 14.4187 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0938 4.74375 13.2563C5.90625 14.4187 7.325 15 9 15ZM9.075 5.775C9.3875 5.775 9.65938 5.875 9.89062 6.075C10.1219 6.275 10.2375 6.525 10.2375 6.825C10.2375 7.1 10.1531 7.34375 9.98438 7.55625C9.81563 7.76875 9.625 7.96875 9.4125 8.15625C9.125 8.40625 8.87188 8.68125 8.65313 8.98125C8.43438 9.28125 8.325 9.61875 8.325 9.99375C8.325 10.1687 8.39062 10.3156 8.52188 10.4344C8.65313 10.5531 8.80625 10.6125 8.98125 10.6125C9.16875 10.6125 9.32812 10.55 9.45938 10.425C9.59062 10.3 9.675 10.1438 9.7125 9.95625C9.7625 9.69375 9.875 9.45938 10.05 9.25313C10.225 9.04688 10.4125 8.85 10.6125 8.6625C10.9 8.3875 11.1469 8.0875 11.3531 7.7625C11.5594 7.4375 11.6625 7.075 11.6625 6.675C11.6625 6.0375 11.4031 5.51562 10.8844 5.10938C10.3656 4.70312 9.7625 4.5 9.075 4.5C8.6 4.5 8.14688 4.6 7.71563 4.8C7.28438 5 6.95625 5.30625 6.73125 5.71875C6.64375 5.86875 6.61562 6.02813 6.64688 6.19688C6.67813 6.36563 6.7625 6.49375 6.9 6.58125C7.075 6.68125 7.25625 6.7125 7.44375 6.675C7.63125 6.6375 7.7875 6.53125 7.9125 6.35625C8.05 6.16875 8.22188 6.025 8.42813 5.925C8.63438 5.825 8.85 5.775 9.075 5.775Z"
                          fill="#667085"
                        />
                      </g>
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="boxSetting">
                    <Dropdown.Item
                      onClick={() =>
                        window.open('https://help.tagturbo.com/', '_blank')
                      }
                      className="dropdown-p-xs dropdown-item-setting text-14"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        className="mr-2"
                      >
                        <mask
                          id="mask0_14382_324371"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="18"
                        >
                          <rect width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_14382_324371)">
                          <path
                            d="M6 10.5H8.00625C8.14375 10.2125 8.30312 9.94375 8.48438 9.69375C8.66563 9.44375 8.86875 9.2125 9.09375 9H6C5.7875 9 5.60938 9.07188 5.46562 9.21563C5.32187 9.35938 5.25 9.5375 5.25 9.75C5.25 9.9625 5.32187 10.1406 5.46562 10.2844C5.60938 10.4281 5.7875 10.5 6 10.5ZM6 13.5H7.55625C7.51875 13.25 7.5 13 7.5 12.75C7.5 12.5 7.51875 12.25 7.55625 12H6C5.7875 12 5.60938 12.0719 5.46562 12.2156C5.32187 12.3594 5.25 12.5375 5.25 12.75C5.25 12.9625 5.32187 13.1406 5.46562 13.2844C5.60938 13.4281 5.7875 13.5 6 13.5ZM3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69063 16.0594C2.39688 15.7656 2.25 15.4125 2.25 15V3C2.25 2.5875 2.39688 2.23438 2.69063 1.94063C2.98438 1.64688 3.3375 1.5 3.75 1.5H9.13125C9.33125 1.5 9.52187 1.5375 9.70312 1.6125C9.88438 1.6875 10.0437 1.79375 10.1812 1.93125L13.8188 5.56875C13.9563 5.70625 14.0625 5.86562 14.1375 6.04688C14.2125 6.22813 14.25 6.41875 14.25 6.61875V7.725C14.0125 7.65 13.7688 7.59375 13.5188 7.55625C13.2688 7.51875 13.0125 7.5 12.75 7.5V6.75H9.75C9.5375 6.75 9.35938 6.67812 9.21563 6.53438C9.07188 6.39062 9 6.2125 9 6V3H3.75V15H8.00625C8.14375 15.2875 8.30312 15.5563 8.48438 15.8063C8.66563 16.0563 8.86875 16.2875 9.09375 16.5H3.75ZM12.75 9C13.7875 9 14.6719 9.36563 15.4031 10.0969C16.1344 10.8281 16.5 11.7125 16.5 12.75C16.5 13.7875 16.1344 14.6719 15.4031 15.4031C14.6719 16.1344 13.7875 16.5 12.75 16.5C11.7125 16.5 10.8281 16.1344 10.0969 15.4031C9.36563 14.6719 9 13.7875 9 12.75C9 11.7125 9.36563 10.8281 10.0969 10.0969C10.8281 9.36563 11.7125 9 12.75 9ZM12.75 15C12.8875 15 13.0031 14.9531 13.0969 14.8594C13.1906 14.7656 13.2375 14.65 13.2375 14.5125C13.2375 14.375 13.1906 14.2594 13.0969 14.1656C13.0031 14.0719 12.8875 14.025 12.75 14.025C12.6125 14.025 12.4969 14.0719 12.4031 14.1656C12.3094 14.2594 12.2625 14.375 12.2625 14.5125C12.2625 14.65 12.3094 14.7656 12.4031 14.8594C12.4969 14.9531 12.6125 15 12.75 15ZM12.75 10.5C12.5125 10.5 12.2937 10.5594 12.0938 10.6781C11.8938 10.7969 11.7313 10.9563 11.6063 11.1562C11.5563 11.2312 11.55 11.3094 11.5875 11.3906C11.625 11.4719 11.6875 11.5312 11.775 11.5688C11.85 11.6062 11.925 11.6062 12 11.5688C12.075 11.5312 12.1438 11.4813 12.2063 11.4188C12.2688 11.3313 12.3469 11.2625 12.4406 11.2125C12.5344 11.1625 12.6375 11.1375 12.75 11.1375C12.9125 11.1375 13.0531 11.1906 13.1719 11.2969C13.2906 11.4031 13.35 11.5375 13.35 11.7C13.35 11.8375 13.3125 11.9531 13.2375 12.0469C13.1625 12.1406 13.075 12.2375 12.975 12.3375C12.9 12.4125 12.8219 12.4875 12.7406 12.5625C12.6594 12.6375 12.5875 12.725 12.525 12.825C12.4875 12.9 12.4594 12.9781 12.4406 13.0594C12.4219 13.1406 12.4125 13.225 12.4125 13.3125C12.4125 13.425 12.4438 13.5281 12.5063 13.6219C12.5688 13.7156 12.65 13.7625 12.75 13.7625C12.85 13.7625 12.9312 13.725 12.9937 13.65C13.0562 13.575 13.0875 13.4875 13.0875 13.3875C13.0875 13.25 13.125 13.1281 13.2 13.0219C13.275 12.9156 13.3625 12.8125 13.4625 12.7125C13.6125 12.575 13.7438 12.4219 13.8563 12.2531C13.9688 12.0844 14.025 11.9 14.025 11.7C14.025 11.3625 13.9 11.0781 13.65 10.8469C13.4 10.6156 13.1 10.5 12.75 10.5Z"
                            fill="#667085"
                          />
                        </g>
                      </svg>{' '}
                      Help Center
                    </Dropdown.Item>
                    {activePlanName ? (
                      <Dropdown.Item
                        onClick={() => handleOpenChat()}
                        className="dropdown-p-xs dropdown-item-setting  text-14"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          className="mr-2"
                        >
                          <mask
                            id="mask0_14382_324374"
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="18"
                            height="18"
                          >
                            <rect width="18" height="18" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_14382_324374)">
                            <path
                              d="M3.75 15C3.3375 15 2.98438 14.8531 2.69063 14.5594C2.39688 14.2656 2.25 13.9125 2.25 13.5V8.25C2.25 7.325 2.42813 6.45312 2.78438 5.63438C3.14062 4.81563 3.625 4.1 4.2375 3.4875C4.85 2.875 5.56563 2.39062 6.38438 2.03438C7.20312 1.67813 8.075 1.5 9 1.5C9.925 1.5 10.7969 1.67813 11.6156 2.03438C12.4344 2.39062 13.15 2.875 13.7625 3.4875C14.375 4.1 14.8594 4.81563 15.2156 5.63438C15.5719 6.45312 15.75 7.325 15.75 8.25V15.75C15.75 16.1625 15.6031 16.5156 15.3094 16.8094C15.0156 17.1031 14.6625 17.25 14.25 17.25H9.75C9.5375 17.25 9.35938 17.1781 9.21563 17.0344C9.07188 16.8906 9 16.7125 9 16.5C9 16.2875 9.07188 16.1094 9.21563 15.9656C9.35938 15.8219 9.5375 15.75 9.75 15.75H14.25V15H12.75C12.3375 15 11.9844 14.8531 11.6906 14.5594C11.3969 14.2656 11.25 13.9125 11.25 13.5V10.5C11.25 10.0875 11.3969 9.73438 11.6906 9.44063C11.9844 9.14688 12.3375 9 12.75 9H14.25V8.25C14.25 6.8 13.7375 5.5625 12.7125 4.5375C11.6875 3.5125 10.45 3 9 3C7.55 3 6.3125 3.5125 5.2875 4.5375C4.2625 5.5625 3.75 6.8 3.75 8.25V9H5.25C5.6625 9 6.01562 9.14688 6.30937 9.44063C6.60313 9.73438 6.75 10.0875 6.75 10.5V13.5C6.75 13.9125 6.60313 14.2656 6.30937 14.5594C6.01562 14.8531 5.6625 15 5.25 15H3.75ZM3.75 13.5H5.25V10.5H3.75V13.5ZM12.75 13.5H14.25V10.5H12.75V13.5Z"
                              fill="#667085"
                            />
                          </g>
                        </svg>
                        {` `}Chat with Us
                      </Dropdown.Item>
                    ) : (
                      ''
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}
              <Dropdown className="mx-2 cursor">
                <Dropdown.Toggle className="dropdown-outline">
                  <div className="icon-name-info">{userName}</div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="boxSetting">
                  <Dropdown.Item
                    onClick={() => (window.location.href = '/profilesettings')}
                    className="dropdown-p-xs dropdown-item-setting text-14"
                  >
                    Profile
                  </Dropdown.Item>
                  {/* <Dropdown.Item
                    onClick={() =>
                      (window.location.href = `/billing/${accountId}/${workspaceId}`)
                    }
                    className="dropdown-item-setting text-14"
                  >
                    Billing
                  </Dropdown.Item> */}
                  <Dropdown.Item
                    onClick={() => logout()}
                    className="dropdown-p-xs dropdown-item-setting text-danger text-14"
                  >
                    Sign Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Fragment>
          </div>
        </div>
      </div>

      {showDropdownAccount && (
        <div className="card w-50 dropdown-menu-top box-shadow-center">
          <div className="card-header d-flex p-0 dropdown-item-setting bg-white">
            <div className="w-275 border-end">
              <div className="px-3 py-1 h-40 text-12 d-grid-topbar">
                Account
              </div>
            </div>
            <div className="w-75">
              <div className="px-3 py-1 h-40  text-12 d-grid-topbar">
                Workspace
              </div>
            </div>
          </div>
          <div className="card-body d-flex p-0">
            <div className="w-275 border-end body-drop-menu dropdown_account">
              {accountList.length > 0 &&
                accountList.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className={`px-3 py-3 d-flex text-14 justify-content-between account-hover -pointer ${
                        item.state === 'close' ? 'd-none' : ''
                      } dropdown_account ${
                        item.id === accountId ? 'account-active' : ''
                      }`}
                      onClick={() => handleSelectAccount(item)}
                      // onClick={() => setWorkspace(item.workspace_list)}
                    >
                      {item.name}
                      <MdKeyboardArrowRight />
                    </div>
                  )
                })}
            </div>

            <div className="w-75 body-drop-menu dropdown_account">
              {workspace.length > 0 &&
                workspace.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className={`px-3 py-3 text-14 account-hover -pointer dropdown_account ${
                        item.id === workspaceId ? 'account-active' : ''
                      }`}
                      onClick={() => selectedWorkspace(item)}
                    >
                      <div className="dropdown_account">{item.name}</div>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      )}

      <Modal
        shouldCloseOnOverlayClick={false}
        closeTimeoutMS={200}
        ariaHideApp={false}
        isOpen={openPopupAccountSuspended}
        contentLabel="modal"
        style={customStylesMD}
        onRequestClose={() => setOpenPopupAccountSuspended(false)}
        className={'modal-Publish-box animate-5 fadeIn two'}
      >
        <div className="modal-dialog modal-md ">
          <div className="modal-content">
            <div className="modal-header bg-danger">
              <div className="p-1 text-white">
                <p className="py-0 mb-0 text-20"></p>
              </div>
            </div>

            <div className="modal-body p-3 mt-3 text-center">
              <img className="mb-2" src="/assets/img/warning.png" />

              <p className="text-20 text-danger">
                This Account is Currently Suspended
              </p>
              <p className="text-14">
                You cannot access this workspace due to the suspension of the
                account. Please contact your Super Account Admin to reactivate
                the account to ensure continuous data stream.
              </p>
            </div>
            <div className="modal-footer justify-content-center px-5 pb-5">
              <div
                className="btn btn-danger w-50"
                onClick={() => setOpenPopupAccountSuspended(false)}
              >
                Close
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </TopbarSettingsBox>
  )
}

export default TopbarSettingsComponent
